import { createSelector } from 'reselect';
import _ from 'lodash';
import {osFamilySelector} from '../../common/common';

export const checkoutSelector = state => state.quickCheckout.quickCheckout;

export const productIdSelector = createSelector(
  checkoutSelector,
  quickCheckout => _.get(quickCheckout, 'productId', '')
);

export const productNameSelector = createSelector(
  checkoutSelector,
  quickCheckout => _.get(quickCheckout, 'productName', '')
);

export const channelRedirectUrl = createSelector(
  osFamilySelector,
  productIdSelector,
  (os, productId) => {
    const urlType = os === 'iOS' || os === 'Android' ? os : 'Web';

    return `quickCheckoutProducts.${productId}.redirectUrl.${urlType}`;
  }
);

export const backNavUrl = createSelector(
  productIdSelector,
  productId => `quickCheckoutProducts.${productId}.backNav`
);



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/quickCheckout/quickCheckoutSelectors.js
 **/